import PageShell from '../components/PageShell'
import { FEATURES, APP_REGISTER_URL } from '../content/site'

export default function FeaturesPage() {
  return (
    <PageShell
      title="Features"
      intro="ProcurAlerts is built for New England trade contractors who want to stop chasing bids across dozens of portals and start winning them. Here is what the product does today."
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
        {FEATURES.map((feature) => {
          const Icon = feature.icon
          return (
            <div
              key={feature.title}
              className="bg-white/[0.03] border border-white/[0.06] rounded-xl p-7"
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <Icon size={26} className="text-[#06b6d4]" />
              </div>
              <h2 className="mt-4 text-lg font-semibold text-white leading-[1.3]">
                {feature.title}
              </h2>
              <p className="mt-2 text-sm leading-[1.6] text-[#9ca3af]">{feature.desc}</p>
            </div>
          )
        })}
      </div>

      <section className="mb-12">
        <h2 className="text-xl font-semibold text-white mb-3">Coverage you can plan around</h2>
        <p className="text-[15px] text-[#9ca3af] leading-[1.7] mb-4">
          ProcurAlerts focuses on the six New England states — Massachusetts, Connecticut,
          Maine, New Hampshire, Rhode Island, and Vermont — monitoring municipal portals,
          state procurement systems, housing authorities, and transit agencies. We prioritize
          depth in this region over broad but shallow national coverage; no procurement
          aggregator can guarantee that every posting from every source is captured, so bids
          should always be confirmed against the issuing agency.
        </p>
      </section>

      <section className="mb-12">
        <h2 className="text-xl font-semibold text-white mb-3">From discovery to submission</h2>
        <p className="text-[15px] text-[#9ca3af] leading-[1.7]">
          Beyond alerts, ProcurAlerts helps you act: deadline-sorted daily digests, a watchlist
          pipeline from Watching to Won/Lost, bid decision summaries based on the information
          available for each opportunity, a Document Vault with expiry tracking, and a Bid
          Package generator that assembles your submission documents. Team plans add a shared
          company profile and per-member trade and territory settings.
        </p>
      </section>

      <a
        href={APP_REGISTER_URL}
        className="inline-block bg-[#06b6d4] text-[#0d1117] text-sm font-semibold px-6 py-3 rounded-lg hover:bg-[#22d3ee] transition-all duration-200"
      >
        Start your 14-day free trial
      </a>
    </PageShell>
  )
}
